export default __webpack_public_path__ + "static/media/Badge.f81774ef.svg";